// Global country + currency catalog powering the Job Creation form.
// Each entry: ISO country code, display name, currency code (ISO 4217),
// currency symbol (what the AI voice reads AND the UI badge shows),
// and whether the symbol is prefixed or suffixed. Numbers always render
// with locale-aware grouping (en-IN for lakhs/crores, en-US otherwise).
// Keep this list focused on markets RecruitSift tenants actually hire in —
// not every ISO country. Alphabetical for easy scanning in the dropdown.

export const COUNTRIES = [
  { code: "AR", name: "Argentina",       currency: "ARS", symbol: "AR$",  prefix: true,  locale: "es-AR" },
  { code: "AU", name: "Australia",       currency: "AUD", symbol: "A$",   prefix: true,  locale: "en-AU" },
  { code: "BR", name: "Brazil",          currency: "BRL", symbol: "R$",   prefix: true,  locale: "pt-BR" },
  { code: "CA", name: "Canada",          currency: "CAD", symbol: "C$",   prefix: true,  locale: "en-CA" },
  { code: "CH", name: "Switzerland",     currency: "CHF", symbol: "CHF ", prefix: true,  locale: "de-CH" },
  { code: "CL", name: "Chile",           currency: "CLP", symbol: "CLP$", prefix: true,  locale: "es-CL" },
  { code: "CN", name: "China",           currency: "CNY", symbol: "¥",    prefix: true,  locale: "zh-CN" },
  { code: "CO", name: "Colombia",        currency: "COP", symbol: "COL$", prefix: true,  locale: "es-CO" },
  { code: "CZ", name: "Czech Republic",  currency: "CZK", symbol: " Kč",  prefix: false, locale: "cs-CZ" },
  { code: "DE", name: "Germany",         currency: "EUR", symbol: "€",    prefix: true,  locale: "de-DE" },
  { code: "DK", name: "Denmark",         currency: "DKK", symbol: " kr",  prefix: false, locale: "da-DK" },
  { code: "EG", name: "Egypt",           currency: "EGP", symbol: "E£",   prefix: true,  locale: "ar-EG" },
  { code: "ES", name: "Spain",           currency: "EUR", symbol: "€",    prefix: true,  locale: "es-ES" },
  { code: "FR", name: "France",          currency: "EUR", symbol: "€",    prefix: true,  locale: "fr-FR" },
  { code: "GB", name: "United Kingdom",  currency: "GBP", symbol: "£",    prefix: true,  locale: "en-GB" },
  { code: "HK", name: "Hong Kong",       currency: "HKD", symbol: "HK$",  prefix: true,  locale: "zh-HK" },
  { code: "ID", name: "Indonesia",       currency: "IDR", symbol: "Rp",   prefix: true,  locale: "id-ID" },
  { code: "IE", name: "Ireland",         currency: "EUR", symbol: "€",    prefix: true,  locale: "en-IE" },
  { code: "IL", name: "Israel",          currency: "ILS", symbol: "₪",    prefix: true,  locale: "he-IL" },
  { code: "IN", name: "India",           currency: "INR", symbol: "₹",    prefix: true,  locale: "en-IN" },
  { code: "IT", name: "Italy",           currency: "EUR", symbol: "€",    prefix: true,  locale: "it-IT" },
  { code: "JP", name: "Japan",           currency: "JPY", symbol: "¥",    prefix: true,  locale: "ja-JP" },
  { code: "KE", name: "Kenya",           currency: "KES", symbol: "KSh ", prefix: true,  locale: "en-KE" },
  { code: "KR", name: "South Korea",     currency: "KRW", symbol: "₩",    prefix: true,  locale: "ko-KR" },
  { code: "MX", name: "Mexico",          currency: "MXN", symbol: "MX$",  prefix: true,  locale: "es-MX" },
  { code: "MY", name: "Malaysia",        currency: "MYR", symbol: "RM",   prefix: true,  locale: "ms-MY" },
  { code: "NG", name: "Nigeria",         currency: "NGN", symbol: "₦",    prefix: true,  locale: "en-NG" },
  { code: "NL", name: "Netherlands",     currency: "EUR", symbol: "€",    prefix: true,  locale: "nl-NL" },
  { code: "NO", name: "Norway",          currency: "NOK", symbol: " kr",  prefix: false, locale: "nb-NO" },
  { code: "NZ", name: "New Zealand",     currency: "NZD", symbol: "NZ$",  prefix: true,  locale: "en-NZ" },
  { code: "PH", name: "Philippines",     currency: "PHP", symbol: "₱",    prefix: true,  locale: "en-PH" },
  { code: "PK", name: "Pakistan",        currency: "PKR", symbol: "Rs ",  prefix: true,  locale: "en-PK" },
  { code: "PL", name: "Poland",          currency: "PLN", symbol: " zł",  prefix: false, locale: "pl-PL" },
  { code: "PT", name: "Portugal",        currency: "EUR", symbol: "€",    prefix: true,  locale: "pt-PT" },
  { code: "RO", name: "Romania",         currency: "RON", symbol: " lei", prefix: false, locale: "ro-RO" },
  { code: "SA", name: "Saudi Arabia",    currency: "SAR", symbol: "SR ",  prefix: true,  locale: "ar-SA" },
  { code: "SE", name: "Sweden",          currency: "SEK", symbol: " kr",  prefix: false, locale: "sv-SE" },
  { code: "SG", name: "Singapore",       currency: "SGD", symbol: "S$",   prefix: true,  locale: "en-SG" },
  { code: "TH", name: "Thailand",        currency: "THB", symbol: "฿",    prefix: true,  locale: "th-TH" },
  { code: "TR", name: "Türkiye",         currency: "TRY", symbol: "₺",    prefix: true,  locale: "tr-TR" },
  { code: "TW", name: "Taiwan",          currency: "TWD", symbol: "NT$",  prefix: true,  locale: "zh-TW" },
  { code: "UA", name: "Ukraine",         currency: "UAH", symbol: "₴",    prefix: true,  locale: "uk-UA" },
  { code: "AE", name: "United Arab Emirates", currency: "AED", symbol: "AED ", prefix: true, locale: "en-AE" },
  { code: "US", name: "United States",   currency: "USD", symbol: "$",    prefix: true,  locale: "en-US" },
  { code: "VN", name: "Vietnam",         currency: "VND", symbol: "₫",    prefix: false, locale: "vi-VN" },
  { code: "ZA", name: "South Africa",    currency: "ZAR", symbol: "R",    prefix: true,  locale: "en-ZA" },
].sort((a, b) => a.name.localeCompare(b.name));

export const CURRENCY_BY_CODE = Object.fromEntries(
  COUNTRIES.map((c) => [c.currency, c])
);

/** Format an integer amount in the given currency using locale grouping. */
export function fmtMoney(amount, currencyCode) {
  const n = Number(amount || 0);
  const meta = CURRENCY_BY_CODE[currencyCode] || CURRENCY_BY_CODE.USD;
  const grouped = n.toLocaleString(meta.locale, { maximumFractionDigits: 0 });
  return meta.prefix ? `${meta.symbol}${grouped}` : `${grouped}${meta.symbol}`;
}

/** Format a salary band like "₹20,00,000 – ₹30,00,000" or "$120,000 – $180,000". */
export const LAKH = 100000;
export const isLpa = (currencyCode, unit) => currencyCode === "INR" && unit !== "annual";
const lakhs = (n) => String(Math.round((n / LAKH) * 100) / 100);
// Form helpers: LPA inputs hold lakhs; the API always stores full rupee amounts.
export const salaryToInput = (amount, unit) => (!amount ? "" : unit === "lpa" ? lakhs(Number(amount)) : String(amount));
export const salaryFromInput = (val, unit) => Math.round(Number(val || 0) * (unit === "lpa" ? LAKH : 1));

export function fmtSalaryBand(min, max, currencyCode, unit) {
  const lo = Number(min || 0); const hi = Number(max || 0);
  if (!lo && !hi) return "";
  if (isLpa(currencyCode, unit)) {
    if (lo && hi) return `₹${lakhs(lo)} – ${lakhs(hi)} LPA`;
    return lo ? `₹${lakhs(lo)}+ LPA` : `up to ₹${lakhs(hi)} LPA`;
  }
  if (lo && !hi) return fmtMoney(lo, currencyCode) + "+";
  if (!lo && hi) return "up to " + fmtMoney(hi, currencyCode);
  return `${fmtMoney(lo, currencyCode)} – ${fmtMoney(hi, currencyCode)}`;
}

export const COUNTRY_BY_CODE = Object.fromEntries(COUNTRIES.map((c) => [c.code, c]));
